import { useGetSchoolCoursesList, useGetSchoolTeachersList } from '../../../assets/nodeApi/getApi/getSchoolApi'

export const useSchoolDropdownOptions = () => {
  const { data: CourseList, isLoading: isLoadingCourseList } = useGetSchoolCoursesList();
  const { data: TeacherList, isLoading: isLoadingTeacherList } = useGetSchoolTeachersList();

  const schoolCourseOptions =
    CourseList?.data?.map((item,index) => ({
      id: item.event_id,
      label: item.title,
      value: item.title,
      sr_no:index+1,
      ...item
    })) ?? [];

  const schoolTeacherOptions =
    TeacherList?.data?.map((item) => ({
      id: item.id,
      label: `${item?.firstname} ${item?.lastname}`,
      value: `${item?.firstname} ${item?.lastname}`,
       ...item
    })) ?? [];

  return {
    schoolCourse: {
      options: schoolCourseOptions,
      isLoading: isLoadingCourseList,
    },
    schoolTeacher: {
      options: schoolTeacherOptions,
      isLoading: isLoadingTeacherList,
    },
  };
};
